<template>
    <div class="eda-button-pair" :class="{'eda-button-pair--invisible': !visible}">
        <but :secondary="true" :loading="loading.secondary" :error="error.secondary" :visible="visible" @click="$emit('secondary-click')">
            {{ labels.secondary }}
        </but>
        <but :loading="loading.primary" :error="error.primary" :visible="visible" @click="$emit('primary-click')">
            {{ labels.primary }}
        </but>
    </div>
</template>

<script>
    import but from "./vButton";

    export default {
        name: "EdaButtonPair",
        components: {
            but
        },
        props: {
            loading: {
                type: Object, default: function () {
                    return {primary: false, secondary: false}
                }
            },
            error: {
                type: Object, default: function () {
                    return {primary: false, secondary: false}
                }
            },
            visible: {type: Boolean, default: true},
            labels: {type: Object, default: {primary: "", secondary: ""}}

        },
    }
</script>

<style>

    .eda-button-pair {
        display: flex;
        padding-top: 1em;
        font-size: 0.8em;
        justify-content: flex-end;
        transition: all 0.2s cubic-bezier(.5, 0, 0, 1);

    }

    .eda-button-pair--invisible {
        padding: 0;

    }
</style>